export function ProductService($http, apexApiUrl) {
    'ngInject';
    return {
        createProduct: createProduct,
        retrieveProducts: retrieveProducts,
        updateProduct: updateProduct,
        deleteProduct: deleteProduct
    };

    function retrieveProducts() {
        return $http({
            method: "GET",
            url: apexApiUrl + "products",
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    function createProduct(data) {

        return $http({
            method: "POST",
            data: data,
            url: apexApiUrl + "products",
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    function updateProduct(id, productLine) {

        return $http({
            method: "PUT",
            url: apexApiUrl + "products/" + id,
            data: productLine

        });
    }

    function deleteProduct(id) {
        return $http({
            method: "DELETE",
            url: apexApiUrl + "products/" + id
        });
    }
}
